export class Utilisateur {
        userId: string;
        nom: string;
        prenom: string;
        userName: string;
        dateDeNaissance:string;
        sexe: string;
        email: string;
        motPasse: string;
        poste: string;
        compagnie: string;
        numTelephone: string;
        pays: string;
       description: string;
       urlPhotoCouverture: string;
       urlPhotoProfil: string;
       groupe: string[] =[];
       watchlist: string[]=[]

     }
    
